import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import EmojiWarningPopup from "./EmojiWarningPopup";
import { HiPlus, HiSearch } from "react-icons/hi";
import coins_image from "../../../../assets/img/coin/coins_image.png";
import CoinWarningPopup from "./CoinWarningPopup";
import CoinEditPopup from "./CoinEditPopup";
import Pagination from "Components/Pagination/Pagination";
import { usePermission } from "Context/PermissionContext";
import { loadDecrypted } from "Common Usage/localStorageUtils";

const CoinsList = ({
  handleAddModalOpen,
  coinPlans,
  coinDataLoading,
  fetchCoinPlans,
  promoPlans,
}) => {
  const [warnPopupOpen, setWarnPopupOpen] = useState(false);
  const [EditCoinModalOpen, setEditCoinModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [coinDetails, setCoinDetails] = useState([]);
  const { permissions } = usePermission();
  const currentTabPermissions =
    permissions?.coinManagement?.subModule?.manageCoins?.permissions;

  const loggedInUser = loadDecrypted("HeartConnect-StaffData");
  const staffData = Array.isArray(loggedInUser)
    ? loggedInUser[0]
    : loggedInUser;
  const staffId = staffData?._id || staffData?.id || "";

  const handleOpen = (plan) => {
    setCoinDetails(plan);
    setWarnPopupOpen(true);
  };

  const handleClose = () => setWarnPopupOpen(false);

  const handleOpenEdit = (item) => {
    setCoinDetails(item);
    setEditCoinModalOpen(true);
  };
  const handleEditModalClose = () => setEditCoinModalOpen(false);

  const calculateDiscountedPrice = (price, discount) => {
    return price - (price * discount) / 100;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(coinPlans.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const paginatedCoin = coinPlans.slice(indexOfFirst, indexOfLast);

  return (
    <React.Fragment>
      <CoinWarningPopup
        warnPopupOpen={warnPopupOpen}
        handleClose={handleClose}
        coinDetails={coinDetails}
        fetchCoinPlans={fetchCoinPlans}
        staffId={staffId}
      />

      <CoinEditPopup
        EditCoinModalOpen={EditCoinModalOpen}
        promoPlans={promoPlans}
        handleEditModalClose={handleEditModalClose}
        coinDetails={coinDetails}
        fetchCoinPlans={fetchCoinPlans}
        staffId={staffId}
      />

      <div className="py-5">
        <div className="flex flex-col items-center justify-between space-y-4 rounded-2xl bg-white p-5 shadow-sm md:flex-row md:space-y-0">
          {/* Search Bar */}
          <div className="w-full md:w-1/2 md:flex-1">
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
                <HiSearch color="#c51369" className="h-5 w-5" />
              </span>
              <input
                type="text"
                placeholder="Search by Coin Packages"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="block w-full rounded-md border px-4 py-2 pl-10 text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#c51369] md:w-1/2"
              />
            </div>
          </div>

          {/* Plus Button */}
          {currentTabPermissions?.create && (
            <div className="w-full md:w-auto">
              <button
                onClick={handleAddModalOpen}
                className="flex w-full items-center justify-center rounded-full bg-[#c51369] p-3 text-white hover:bg-[#a10f5b] hover:shadow-lg focus:outline-none md:w-auto"
              >
                <HiPlus className="h-5 w-5" />
              </button>
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 gap-6 py-5 sm:grid-cols-2 lg:grid-cols-4">
          {coinDataLoading
            ? Array(8)
                .fill(null)
                .map((_, index) => (
                  <div
                    key={index}
                    className="animate-pulse rounded-lg bg-gray-200 p-4 shadow-md"
                  >
                    <div className="mb-4 h-40 rounded-lg bg-gray-300"></div>
                    <div className="mb-2 h-6 rounded bg-gray-300"></div>
                    <div className="mb-2 h-4 rounded bg-gray-300"></div>
                    <div className="h-6 rounded bg-gray-300"></div>
                  </div>
                ))
            : paginatedCoin.map((plan, index) => (
                <div
                  key={index}
                  className="rounded-xl border bg-white shadow-md transition-shadow duration-300 hover:shadow-lg"
                >
                  {/* Image Section */}
                  <div className="relative overflow-hidden rounded-t-xl bg-gradient-to-tr from-pink-400 to-pink-700">
                    <img
                      src={coins_image}
                      alt="Buy Coin"
                      className="h-[170px] w-full transform rounded-t-xl object-cover transition-transform duration-300 hover:scale-105"
                    />
                    <div className="absolute left-4 top-4 rounded-lg bg-gradient-to-r from-pink-500 to-red-500 px-3 py-1 text-sm tracking-wide text-white shadow">
                      {/* {plan.discount}% OFF */}
                      Up To 50% OFF
                    </div>
                    <div className="absolute right-4 top-4 flex justify-center gap-2">
                      {currentTabPermissions?.edit && (
                        <button
                          onClick={() => handleOpenEdit(plan)}
                          className="flex  items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-[#61c5e6] p-1.5"
                        >
                          <FaEdit
                            size={15}
                            className="cursor-pointer text-white hover:text-gray-300"
                          />
                        </button>
                      )}
                      {currentTabPermissions?.delete && (
                        <button
                          onClick={() => handleOpen(plan)}
                          className="flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-[#61c5e6] p-1.5"
                        >
                          <FaTrash
                            size={15}
                            className="cursor-pointer text-white hover:text-gray-300"
                          />
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="space-y-3 p-4 text-center">
                    {/* <h4 className="text-lg font-bold text-gray-800 tracking-wide">
                                        {plan.title}
                                    </h4> */}
                    <h6 className="text-xl font-semibold text-[#d68a18]">
                      {plan.coinAmount} Coins
                    </h6>
                    <div className="flex items-center justify-center gap-4 text-lg text-gray-700">
                      {/* <p className="text-pink-600 font-semibold">
                                            ₹
                                            {calculateDiscountedPrice(plan.purchaseAmount, plan.discount)}
                                        </p> */}
                      <p className="font-semibold text-pink-600">
                        ₹{plan.purchaseAmount}
                      </p>
                      {/* <p className="line-through text-gray-400">
                                            ₹{plan.purchaseAmount}
                                        </p> */}
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </React.Fragment>
  );
};

export default CoinsList;
